<template>
<div class="raiz">
    <div class="cabecalho">
      <div class="barra">
          <div class="logo">
              <img src="@/assets/logo.png"/>
          </div>
          <!-- <div class="botoes">
            <div class="carrinho" @click="cesta">
              <mdi-carrinho></mdi-carrinho>
            </div>
          </div> -->
      </div>
      <div class="fones">
        <div class="dados">Centro: (21) 99613-9311  (21) 2507-1422</div>
        <div class="dados">Polo Textil: (21) 99613-9634  (21) 2137-5232</div>
      </div>
          <!-- <div class="areapesquisa">
            <div class="pesquisa">
              <div style="width:100%">
                <input type=text class="procure" placeholder="O que você procura?" v-model="pesquisa" />
              </div>
              <div class="lupa">
                <mdi-pesquisa @click="pesquisar"></mdi-pesquisa>
              </div>
            </div>
          </div> -->
      <div class="menuh">
            <div class="menu">
                <div class="items-menuh">
                    <div v-for="a in areas" v-bind:key="a.id" @click="selecionouarea(a.descricao)">
                    <div class="item">{{a.descricao}}</div>
                    </div>
                </div>
            </div>
      </div>
    </div>
    <div class="vitrine">
      <div v-if="ehMovel" class="movel">
        <div v-for="g in grupos" v-bind:key="g.codgrupo">
          <div v-if="g.classe=='item0'" v-bind:class="g.classe" @click="selecionou(g)">
            <div class="imagem0">
              <img :src="'' + g.imagem + ''"/>
            </div>
            <div class="descricao0">{{ g.grupo }}</div>
          </div>
          <div v-if="g.classe=='item1'" v-bind:class="g.classe" @click="selecionou(g)">
            <div class="descricao1">{{ g.grupo }}</div>
            <div class="imagem1">
              <img :src="'' + g.imagem + ''"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!ehMovel" class="desktop">
        <div v-for="g in grupos" v-bind:key="g.codgrupo">
          <div class="grupo"  @click="selecionou(g)">
            <div class="imagem">
              <img :src="'' + g.imagem + ''"/>
            </div>
            <div class="descricao">{{ g.grupo }}</div>
          </div>
        </div>
      </div>
    </div>
    <rodape></rodape>
</div>
</template>

<style lang="scss" scoped>
  @import "@/assets/scss/vitrine.scss";

</style>

<script>
import mvitrine from '@/dados/mvitrine'

// import Submenuh from '../components/submenuh.vue'
import Rodape from '../components/rodape.vue'

export default {
  components:{
    // 'submenuh': Submenuh,
    'rodape': Rodape,
  },
  data: function(){

    return {
      topo: '200px',

      pesquisa: "",

      areas:  [{id: 1, descricao: "VITRINE"},{id: 2, descricao: "NOIVA"},{id: 3, descricao: "FESTA"}
            ,{id: 4, descricao: "DIA A DIA"},{id: 5, descricao: "PROMOÇÃO"}],

      ehMovel: false,

      grupos: null,
      referencias: null,
      temCarrinho: false,
    }

  },
  methods:{
    pesquisar: function(){
      if (this.pequisa != ""){
        this.$store.commit("pesquisaLivreMudou",this.pesquisa);
      }
    },
    cesta: function(){
      //this.$router.push("cesta");
    },

    selecionouarea(area){
      sessionStorage.setItem("vitrine.area",area);
      mvitrine.recuperarGrupos(area).then(()=>{
        this.grupos = mvitrine.retorno;

      });
    },


    selecionou(g){
      sessionStorage.setItem("vitrine.codgrupo",g.codgrupo);
      sessionStorage.setItem("vitrine.grupo",g.grupo);
      this.$router.push("artigos");

    },
  },
  created(){

    this.ehMovel = window.outerWidth <500;

    this.temCarrinho = false;
    if (localStorage.getItem("vitrine.carrinho") != null && localStorage.getItem("vitrine.carrinho").toString().length > 0){
      this.temCarrinho = true;
    }
    var removeu = false;
    var cesta = localStorage.getItem("vitrine.cesta")
    console.log("cesta " + cesta);
    if (cesta != null){
        for (var i=cesta.length-1;i>=0;i--){
          console.log(cesta[i].datacompra);
          var agora = new Date();
          if (cesta[i].datacompra == undefined || new Date(cesta[i].datacompra) < agora.setDate(agora.getDate()-7)){
            cesta.splice(i,1);
            removeu = true;
          }
          console.log(cesta);
        }
        if (removeu){
              localStorage.setItem('vitrine.cesta',cesta);
        }
    }

  },
  mounted(){

    
        let viewheight = window.outerHeight;
        let viewwidth = window.outerWidth;
        let viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");


    let area = sessionStorage.getItem("vitrine.area");
    area = (area==null?"VITRINE":area);
    sessionStorage.setItem("vitrine.area",area);
    
    mvitrine.recuperarGrupos(area).then(()=>{
      this.grupos = mvitrine.retorno;
    });
    mvitrine.atualizarSaldoReferencias().then(()=>{}
    )
  }
}
</script>